import { createRouter, createWebHistory } from 'vue-router'
import ViewTotal from '@/views/ViewTotal.vue'

const routes = [
  {
    // 登录
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    children: []
  },
  {
    path: '/',
    name: 'home',
    component: ViewTotal,
    children: [{
      path: '/RealTime',
      name: '态势控制',
      component: () => import('@/views/RealTime/RealTime'),   
    },
    {
      path: '/MultiChannelVideo',
      name: '多路视频',
      component: () => import('@/views/MultiChannelVideo/MultiChannelVideo'),
    },
    {
      path: '/CollaborativeScheduling',
      name: '协同调度',
      component: () => import('@/views/CollaborativeScheduling/CollaborativeScheduling'),
    },
    {
      path: '/NewPlan',
      name: '新建计划',
      component: () => import('@/views/NewPlan/NewPlan'),
    },
    {
      path: '/FullChainTraceability',
      name: '全链路溯源',
      component: () => import('@/views/FullChainTraceability/FullChainTraceability'),
    },
    {
      path: '/FisheryServices',
      name: '渔业服务',
      component: () => import('@/views/FisheryServices/FisheryServices'),
    },
    

    {
      path: '/Route',
      name: '航线库',
      component: () => import('@/views/Route/Route'),
    }, {
      path: '/Media',
      name: '媒体库',
      component: () => import('@/views/Media/Media'),
    }, {
      path: '/plan',
      name: '计划库',
      component: () => import('@/views/plan'),
    },]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  mainPages: routes[1].children
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log(to, from)
  next();
});

// 全局后置守卫
router.afterEach((to, from) => {
  console.log(to, from)
});

export default router
